var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tips"},[_c('span',[_vm._v("请使用微信内置浏览器访问")])]),_c('div',{staticClass:"footer"},[_vm._v("湖南麓辰教育科技有限公司 版权所有 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("湘ICP备2021007849号-3")])])])
}]

export { render, staticRenderFns }